import { z } from 'zod';
export const SlackNotificationSchema = z.object({
    text: z.string(),
    blocks: z.unknown(),
});
